import { View } from "../../../../api/api";
import {
  IAction,
  IBooleanValueAction,
  INumericValueAction,
  IViewAction
} from "../../../redux/actions";

export interface IGameSetting {
  key: string;
  name: string;
  value: any;
}

export interface IKeypadButtonAction extends IAction {
  button: string;
}

export interface ISetGameSettingsAction extends IAction {
  settings: IGameSetting[];
}

export enum types {
  DISABLE_KEYPAD_BUTTON = "DISABLE_KEYPAD_BUTTON",
  ENABLE_KEYPAD_BUTTON = "ENABLE_KEYPAD_BUTTON",
  SET_FULLSCREEN_CANVAS_ACTIVE = "SET_FULLSCREEN_CANVAS_ACTIVE",
  SET_GAME_SETTINGS = "SET_GAME_SETTINGS",
  SET_INTRO_MOVIE_AVAILABLE = "SET_INTRO_MOVIE_AVAILABLE",
  SET_INTRO_MOVIE_ENABLED = "SET_INTRO_MOVIE_ENABLED",
  SET_INTRO_SCREEN_AVAILABLE = "SET_INTRO_SCREEN_AVAILABLE",
  SET_INTRO_SCREEN_ENABLED = "SET_INTRO_SCREEN_ENABLED",
  SET_LEFT_HAND_MODE_ACTIVE = "SET_LEFT_HAND_MODE_ACTIVE",
  SET_PLAY_FOR_FUN_ACTIVE = "SET_PLAY_FOR_FUN_ACTIVE",
  SET_QUICKSPIN_AVAILABLE = "SET_QUICKSPIN_AVAILABLE",
  SET_QUICKSPIN_ENABLED = "SET_QUICKSPIN_ENABLED",
  SET_QUICKSPIN_ACTIVE = "SET_QUICKSPIN_ACTIVE",
  SET_SPACEBAR_TO_SPIN_ENABLED = "SET_SPACEBAR_TO_SPIN_ENABLED",
  SET_VOLUME = "SET_VOLUME",
  SOUND_MUTE = "SOUND_MUTE",
  START_SPIN = "START_SPIN",
  STOP_SPIN = "STOP_SPIN",
  TRIGGER_MUTE_CHANGE_REQUEST = "TRIGGER_MUTE_CHANGE_REQUEST",
  TRIGGER_QUICK_SPIN_CHANGE_REQUEST = "TRIGGER_QUICK_SPIN_CHANGE_REQUEST",
  TRIGGER_VIEW_CHANGE_REQUEST = "TRIGGER_VIEW_CHANGE_REQUEST",
  TRIGGER_VOLUME_CHANGE_REQUEST = "TRIGGER_VOLUME_CHANGE_REQUEST"
}

export const triggerDefaultViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.DEFAULT
  };
};

export const triggerAutoplaySettingsViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.AUTOPLAY_SETTINGS
  };
};

export const triggerBetSettingsViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.BET_SETTINGS
  };
};

export const triggerMainSettingsViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.MAIN_SETTINGS
  };
};

export const triggerPaytableViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.PAYTABLE
  };
};

export const triggerGameRulesViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.GAME_RULES
  };
};

export const triggerGameHistoryViewChangeRequest = (): IViewAction => {
  return {
    type: types.TRIGGER_VIEW_CHANGE_REQUEST,
    value: View.GAME_HISTORY
  };
};

export const setPlayForFunActive = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_PLAY_FOR_FUN_ACTIVE,
    value
  };
};

export const setFullscreenCanvasActive = (
  value: boolean
): IBooleanValueAction => {
  return {
    type: types.SET_FULLSCREEN_CANVAS_ACTIVE,
    value
  };
};

export const setLeftHandModeActive = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_LEFT_HAND_MODE_ACTIVE,
    value
  };
};

export const setQuickSpinAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_QUICKSPIN_AVAILABLE,
    value
  };
};

export const setQuickSpinEnabled = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_QUICKSPIN_ENABLED,
    value
  };
};

export const setQuickSpinActive = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_QUICKSPIN_ACTIVE,
    value
  };
};

export const triggerQuickSpinChangeRequest = (
  value: boolean
): IBooleanValueAction => {
  return {
    type: types.TRIGGER_QUICK_SPIN_CHANGE_REQUEST,
    value
  };
};

export const setGameSettings = (
  settings: IGameSetting[]
): ISetGameSettingsAction => {
  return {
    type: types.SET_GAME_SETTINGS,
    settings
  };
};

/* Features */

export const muteSound = (mute: boolean): IBooleanValueAction => {
  return {
    type: types.SOUND_MUTE,
    value: mute
  };
};

export const setVolume = (value: number): INumericValueAction => {
  return {
    type: types.SET_VOLUME,
    value
  };
};

export const triggerVolumeChangeRequest = (
  value: number
): INumericValueAction => {
  return {
    type: types.TRIGGER_VOLUME_CHANGE_REQUEST,
    value
  };
};

export const triggerMuteChangeRequest = (
  value: boolean
): IBooleanValueAction => {
  return {
    type: types.TRIGGER_MUTE_CHANGE_REQUEST,
    value
  };
};

export const startSpin = (): IAction => {
  return { type: types.START_SPIN };
};
export const stopSpin = (): IAction => {
  return { type: types.STOP_SPIN };
};

/* Buttons */

export const enableKeypadButton = (button: string): IKeypadButtonAction => {
  return {
    type: types.ENABLE_KEYPAD_BUTTON,
    button
  };
};

export const disableKeypadButton = (button: string): IKeypadButtonAction => {
  return {
    type: types.DISABLE_KEYPAD_BUTTON,
    button
  };
};
